import { backgroundOrange, orange } from '@/theme/colors'
import styled from 'styled-components'

export const TripsListContainer = styled.div`
	background-color: ${backgroundOrange};
	flex: 1;
	overflow-y: auto;
`

/* Centered column shared with the other section pages (files, flights). */
export const TripsListContent = styled.div`
	max-width: 1400px;
	margin: 0 auto;
	width: 100%;
	padding: 2.5rem 1.5rem 2rem;

	@media (max-width: 600px) {
		padding: 1rem 0.875rem;
	}
`

export const TripsListHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1.5rem;
	gap: 1rem;
	flex-wrap: wrap;

	@media (max-width: 600px) {
		margin-bottom: 1rem;
		gap: 0.75rem;
	}
`

export const TripsGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
	gap: 1.5rem;
	align-items: stretch;

	@media (max-width: 600px) {
		grid-template-columns: 1fr;
		gap: 1rem;
	}
`

export const HeaderActions = styled.div`
	display: flex;
	align-items: center;
	gap: 0.75rem;
	flex-wrap: wrap;

	@media (max-width: 600px) {
		gap: 0.5rem;
		width: 100%;
	}
`

export const HeaderButton = styled.button`
	background: white;
	color: ${orange};
	border: 1px solid ${orange};
	padding: 0.625rem 1rem;
	border-radius: 8px;
	font-size: 0.875rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	gap: 0.5rem;

	&:hover {
		background: ${orange};
		color: white;
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	}

	&:active {
		opacity: 0.85;
		transform: translateY(0);
	}
`

export const LoadingState = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 4rem 2rem;
	color: #6c757d;
	font-size: 1.125rem;
`

export const ErrorState = styled.div`
	background: #f8d7da;
	color: #721c24;
	padding: 1rem;
	border-radius: 8px;
	border: 1px solid #f5c6cb;
	text-align: center;
`

export const EmptyStateContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	min-height: calc(100vh - 200px);
	padding: 2rem;
`

export const EmptyState = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;
	text-align: center;
`

export const EmptyStateIcon = styled.div`
	color: ${orange};
	display: flex;
	align-items: center;
	justify-content: center;
`

export const EmptyStateText = styled.p`
	font-size: 1.125rem;
	color: #495057;
	margin: 0;
	max-width: 500px;
	line-height: 1.6;
`

export const EmptyStateButtons = styled.div`
	display: flex;
	align-items: center;
	gap: 0.75rem;
	flex-wrap: wrap;
	justify-content: center;
`

export const EmptyStateButton = styled.button`
	background: white;
	color: ${orange};
	border: 1px solid ${orange};
	padding: 0.625rem 1rem;
	border-radius: 8px;
	font-size: 0.875rem;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	gap: 0.5rem;

	&:hover {
		background: ${orange};
		color: white;
		transform: translateY(-1px);
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	}

	&:active {
		opacity: 0.85;
		transform: translateY(0);
	}
`
